import { render } from "./Welcome.vue?vue&type=template&id=610e10bf"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=610e10bf&lang=css"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__